var pickerOptions = {
  disabledDate: function disabledDate(time) {
    return time.getTime() > Date.now();
  },
  shortcuts: [{
    text: "本周",
    onClick: function onClick(picker) {
      var now = new Date();
      var start = new Date(now);
      var end = new Date(now);

      // 获取本周一
      var dayOfWeek = now.getDay() === 0 ? 7 : now.getDay(); // 周日为0，转换为7
      start.setDate(now.getDate() - dayOfWeek + 1);
      start.setHours(0, 0, 0, 0);

      // 获取本周日
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);
      picker.$emit("pick", [start, end]);
    }
  }, {
    text: "本月",
    onClick: function onClick(picker) {
      var now = new Date();
      var start = new Date(now.getFullYear(), now.getMonth(), 1);
      var end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      end.setHours(23, 59, 59, 999);
      picker.$emit("pick", [start, end]);
    }
  }, {
    text: "上个月",
    onClick: function onClick(picker) {
      var now = new Date();
      var start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      var end = new Date(now.getFullYear(), now.getMonth(), 0);
      end.setHours(23, 59, 59, 999);
      picker.$emit("pick", [start, end]);
    }
  }, {
    text: "本季度",
    onClick: function onClick(picker) {
      var now = new Date();
      var currentQuarter = Math.floor(now.getMonth() / 3);
      var start = new Date(now.getFullYear(), currentQuarter * 3, 1);
      var end = new Date(now.getFullYear(), currentQuarter * 3 + 3, 0);
      end.setHours(23, 59, 59, 999);
      picker.$emit("pick", [start, end]);
    }
  }]
};
var typeList = [{
  label: "城市大使",
  value: "city_master"
}, {
  label: "校园大使",
  value: "school_master"
}, {
  label: "运营",
  value: "operation"
}];
export { pickerOptions, typeList };